module.exports = __webpack_public_path__ + "img/short02.b1062131.png";